import OutboundLink from 'components/OutboundLink';

//the ticket finder endpoint expects the zero padded violation number
const PADDED_VIOLATION_NUMBER_DATA_SETS = [
	'ecbViolations',
	'ecbViolationsCombined',
	'ecbTicketFinderHearings',
	'oathHearingsCombined',
	'fdnyOathHearings',
];

function ViolationImageLink(props) {
	let { text, dataSet } = props;
	if (!text) return '-';

	let formattedText = String(text);
	if (PADDED_VIOLATION_NUMBER_DATA_SETS.includes(dataSet) && !formattedText.startsWith('0')) {
		formattedText = `0${formattedText}`;
	}

	let url = `https://a820-ecbticketfinder.nyc.gov/GetViolationImage?violationNumber=${formattedText}`;
	return <OutboundLink url={url} iconOnly />;
}

export default ViolationImageLink;
